import { registerCopyEvent } from "../copyable";

registerCopyEvent("peers.server", "copyable_server_id");
